import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import TableDescriptors from '../../../definitions/tableDescriptors';
import LocaleTooling from '../../../tooling/localeTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';

/* Actions */
import * as closedPeriodsAdminActions from '../../actions/closedPeriodsAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';
import * as reportFileActions from '../../actions/reportFileAdmin/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import CalculationsPopup from '../../components/closedPeriodsAdmin/calculationsPopup';
import ReportFilesPopupContainer from '../reportFileAdmin/reportFilesPopupContainer';
import FormPopup from '../../components/periodAdmin/formPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  formPopup: "formPopup",
  calculationsPopup: "calculationsPopup",
  reportFilesPopup: "reportFilesPopup",
  rollBackPeriodConfirmPopup: "rollBackPeriodConfirmPopup",
  deletePeriodConfrmPopup: "deletePeriodConfrmPopup",
}

class ClosedPeriodsAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.periodList,
      entityApiKey: "period",
      initialNewEntity: { start_date: "", end_date: "" },      
      selectedPeriodId: null,      
      selectedPeriodHasReprocess: null,
      connectorSelected: "",
    };
  }
 
  async componentDidMount() {
    await this.props.actions.getPeriodsList();
    EntityTableTooling.fetchList(this);
    await this.props.actions.getCustomer();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {    
    //handle save feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.save.status],
      [this.props.save.status],
      intl.formatMessage( {id: "periodAdmin.createJobPeriodSuccess"}),
      null,
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.formPopup])) {
          InterfaceTooling.popupHide(popupIds.formPopup, this.setState.bind(this));
        }
      }]
    );

    //handle rollback period feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.rollBackPeriod.status],
      [this.props.rollBackPeriod.status],
      intl.formatMessage({ id: "periodAdmin.closePeriodSuccess" }),
      this.props.rollBackPeriod.status==423 ?
        intl.formatMessage({ id: "common.errors.systemLockedError" }) :
        intl.formatMessage({ id: "periodAdmin.closePeriodFailure" }),
      [async () => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.rollBackPeriodConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.rollBackPeriodConfirmPopup, this.setState.bind(this));
        }
      }]
    );

    //handle delete period feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deletePeriod.status],
      [this.props.deletePeriod.status],
      intl.formatMessage({ id: "periodAdmin.deletePeriodSuccess" }),
      this.props.deletePeriod.status==406 ?
        intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
          {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "periodAdmin.entityNameSingularWithArticle"})),
           detail: (this.props.deletePeriod.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.deletePeriod.errors.message : "")
          }) :
      this.props.deletePeriod.status==423 ?
        intl.formatMessage({ id: "common.errors.systemLockedError" }) :
        intl.formatMessage({ id: "periodAdmin.deletePeriodFailure" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.deletePeriodConfrmPopup])) {
          InterfaceTooling.popupHide(popupIds.deletePeriodConfrmPopup, this.setState.bind(this));
        }
        EntityTableTooling.fetchList(this);       
      }]    
    );
    
    //handle download calculation report feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadCalculationReport.status],
      [this.props.downloadCalculationReport.status],
      intl.formatMessage({ id: "calculations.downloadCalculationReportFileSuccess" }),
      intl.formatMessage({ id: "calculations.downloadCalculationReportFileFailure" })
    );
    
    //handle download calculation report feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadCalculationUnifiedReport.status],
      [this.props.downloadCalculationUnifiedReport.status],
      intl.formatMessage({ id: "calculations.downloadCalculationReportFileSuccess" }),
      intl.formatMessage({ id: "calculations.downloadCalculationReportFileFailure" })
    );
    
    if (this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        this.setState({
          initialNewEntity: Object.assign({}, this.state.initialNewEntity, {clone_period_id: this.props.periodsList.data[0].id}),  
        })
      }
    }
  }

  handleCalculationsPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.calculationsPopup, this.state, 
      this.setState.bind(this), this.props.calculationsHistory.loading, () => {
        var period = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          selectedPeriodId: period.id,
          selectedPeriodHasReprocess: period.reprocess_at
        })
        this.props.actions.getCalculationsHistory({
          period_id: period.id,
          per_page: Constants.interface.popupPageSize,
          page: 1
        });
        if(this.state.connectorSelected=="") {
          this.setState({
            connectorSelected: this.props.getCustomer.data.connectors.length>0 ? this.props.getCustomer.data.connectors[0] : ""
          });
        }
      }
    );
  };

  handleCalculationsPopupNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.calculationsHistory.status === 200 && this.props.calculationsHistory.page<=this.props.calculationsHistory.totalPages) {
      this.props.actions.getCalculationsHistory({
        period_id: this.state.selectedPeriodId,
        per_page: Constants.interface.popupPageSize,
        page: page
      });
    }  
  };

  notCalculationUnitsDownloadError = (calculation) => {
    if(!calculation.calculation_units_count) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "periodAdmin.downloadNotCalculationUnitsError"})),"");
      return true;
    }
    return false;
  }

  handleDownloadCalculationReport = async (event) => {
    var calculation = JSON.parse(event.currentTarget.dataset.entitydata); 
    if(this.notCalculationUnitsDownloadError(calculation)) return;   
    await this.props.actions.downloadCalculationReportFile({id: calculation.id});
  };

  handleDownloadCalculationReportCustom = async (event) => {
    var calculation = JSON.parse(event.currentTarget.dataset.entitydata);  
    if(this.notCalculationUnitsDownloadError(calculation)) return;  
    await this.props.actions.downloadCalculationReportFile({
      id: calculation.id,
      report_type: this.state.connectorSelected,
    });
  };

  handleDownloadCalculationUnifiedReport = async (event) => {    
    await this.props.actions.downloadCalculationUnifiedReportFile({period_id: this.state.selectedPeriodId});
  };

  handleDownloadCalculationUnifiedReportCustom = async (event) => {
    await this.props.actions.downloadCalculationUnifiedReportFile({
      period_id: this.state.selectedPeriodId,
      report_type: this.state.connectorSelected,
    });
  };

  handleDownloadCalculationUnifiedReportReprocess = async (event) => {    
    await this.props.actions.downloadCalculationUnifiedReportFile({
      period_id: this.state.selectedPeriodId,
      reprocess: true
    });
  };

  handleDownloadCalculationUnifiedReportCustomReprocess = async (event) => {
    await this.props.actions.downloadCalculationUnifiedReportFile({
      period_id: this.state.selectedPeriodId,
      report_type: this.state.connectorSelected,
      reprocess: true
    });
  };

  handleReportFilesPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.reportFilesPopup, this.state, 
      this.setState.bind(this), this.props.loadingReporFilesHistory, () => {
        var period = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({
          selectedPeriodId: period.id,
          selectedPeriodHasReprocess: period.reprocess_at
        })
        this.props.reportFileActions.getReportFilesHistory({
          period_id: period.id,
          per_page: Constants.interface.popupPageSize,
          page: 1
        }); 
      }
    );
  };

  handleGoToEditPeriod = event => {
    let entityObject = JSON.parse(event.currentTarget.dataset.entitydata);
    if(this.props.fixedPeriodId!="" && this.props.fixedPeriodId!=entityObject.id) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "common.diferentPeriodFixed" }),"");
    }
    else {
      this.props.history.push(Constants.app.routes.calculationsActualPeriod + "/" + entityObject.id);
      this.props.dashboardActions.setActiveMainMenu(Constants.app.routes.calculationsActualPeriod);
    }
  };

  handleRollBackPeriodConfirmPopup = event => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.rollBackPeriodConfirmPopup, this.state, 
      this.setState.bind(this), this.props.rollBackPeriod.loading, () => {
        if(event.currentTarget.dataset.entitydata) {
          var period = JSON.parse(event.currentTarget.dataset.entitydata);
          this.setState({
            selectedPeriodId: period.id,
          })
        }
      }
    );
  }

  handleRollBackPeriod = event => {
    this.props.actions.rollBackPeriod({id: this.state.selectedPeriodId});
  }

  handleDeletePeriod = async () => {
    await this.props.actions.deleteEntity({id: this.props.deletePeriod.id});
  }

  handleDeletePeriodConfirmPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.deletePeriodConfrmPopup, this.state, 
      this.setState.bind(this), this.props.deletePeriod.loading, () => {
        this.props.actions.prepareDeleteEntity(event.currentTarget.dataset.id);
      }
    );
  }

  handleOnChangeConnector = event => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      connectorSelected: value,
    });
  }

  render() {
    var loadingView = (this.props.list.firstLoading || this.props.periodsList.firstLoading) || (this.props.getCustomer.firstLoading || this.props.getCustomer.loading);
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) ||
        (this.props.getCustomer.status !== null && this.props.getCustomer.status !== 200);
    return (
      <section className="dashboard_content_inner_view entity_admin_container closed_periods_admin_container">
        {
          (loadingView) ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                alternativeTitle={intl.formatMessage({ id: "dashboard.mainMenu.calculations_closed_periods"})}
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleGoToEditPeriod}
                handleDelete={this.handleDeletePeriodConfirmPopup}
                handleCustomActions={[this.handleCalculationsPopup, this.handleReportFilesPopup, this.handleRollBackPeriodConfirmPopup]}
                customActionsIcons={["calculator", "copy", "undo"]}
                customActionsTooltips={[
                  intl.formatMessage({ id: "calculations.title"}),
                  intl.formatMessage({ id: "reportFileAdmin.title"}),
                  intl.formatMessage({ id: "periodAdmin.rollBackPeriodConfirmTitle"}),
                ]}
                customActionsForceShow={[true, true, true]}
                colorConfig={[{
                  color: "yellow",
                  column: "state",
                  value: "reprocess"
                }]}
                showDisabledEntitiesText={intl.formatMessage({ id: "periodAdmin.showClosedPeriods"})}
                conditionalCustomActionHide={[null, null, "active"]}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleOnChangeForm={EntityTableTooling.handleOnChangeForm.bind(null, this)}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading}
                statusButton={this.props.save.status}
                periodsList={this.props.periodsList.data}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={<FormattedMessage id="periodAdmin.entityNameSingular"/>}
                popupState={EntityTableTooling.getFormPopupState(this)}
              />    
              <CalculationsPopup
                handleShowPopup={this.handleCalculationsPopup}
                fullLoading={this.props.calculationsHistory.firstLoading || this.props.downloadCalculationReport.loading || this.props.downloadCalculationUnifiedReport.loading}
                tableLoading={this.props.calculationsHistory.loading}
                calculationsState={this.props.calculationsHistory}
                handleCalculationsNextPage={this.handleCalculationsPopupNextPage}
                handleDownloadCalculationReport={this.handleDownloadCalculationReport}
                handleDownloadCalculationReportCustom={this.handleDownloadCalculationReportCustom}
                handleDownloadCalculationUnifiedReport={this.handleDownloadCalculationUnifiedReport}
                handleDownloadCalculationUnifiedReportCustom={this.handleDownloadCalculationUnifiedReportCustom}
                handleDownloadCalculationUnifiedReportReprocess={this.handleDownloadCalculationUnifiedReportReprocess}
                handleDownloadCalculationUnifiedReportCustomReprocess={this.handleDownloadCalculationUnifiedReportCustomReprocess}
                handleJobInfo={this.props.handleNotificationDetailPopupReference}
                hasReprocess={this.state.selectedPeriodHasReprocess}
                popupState={this.state[popupIds.calculationsPopup]}
                customerConnectors={this.props.getCustomer.data.connectors}
                handleSelectConnectors={this.handleOnChangeConnector}
                currentConnector={this.state.connectorSelected}
              />
              <ReportFilesPopupContainer
                popupState={this.state[popupIds.reportFilesPopup]}
                handleRepotFilesPopup={this.handleReportFilesPopup}
                periodId={this.state.selectedPeriodId}
                hasReprocess={this.state.selectedPeriodHasReprocess}
                onlyView={true}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"periodAdmin.rollBackPeriodConfirmTitle"}/>)}
                confirmText={(<FormattedMessage id={"periodAdmin.rollBackPeriodConfirmText"}/>)}
                handleConfirm={this.handleRollBackPeriod}
                handleCancel={this.handleRollBackPeriodConfirmPopup}
                popupState={this.state[popupIds.rollBackPeriodConfirmPopup]}
                loading={this.props.rollBackPeriod.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"periodAdmin.deletePeriodConfirmTitle"}/>)}
                confirmText={(<FormattedMessage id={"periodAdmin.deletePeriodConfirmText"}/>)}
                handleConfirm={this.handleDeletePeriod}
                handleCancel={this.handleDeletePeriodConfirmPopup}
                popupState={this.state[popupIds.deletePeriodConfrmPopup]}
                loading={this.props.deletePeriod.loading}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.closedPeriodsAdmin.list,
  save: state.reducer.closedPeriodsAdmin.save,
  calculationsHistory: state.reducer.closedPeriodsAdmin.calculationsHistory,
  downloadCalculationReport: state.reducer.closedPeriodsAdmin.downloadCalculationReport,
  downloadCalculationUnifiedReport: state.reducer.closedPeriodsAdmin.downloadCalculationUnifiedReport,
  handleNotificationDetailPopupReference: state.reducer.dashboard.handleNotificationDetailPopupReference,
  loadingReporFilesHistory: state.reducer.reportFileAdmin.reportFilesHistory.loading,
  periodsList: state.reducer.closedPeriodsAdmin.periodsList,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId,
  rollBackPeriod: state.reducer.closedPeriodsAdmin.rollBackPeriod,
  deletePeriod: state.reducer.closedPeriodsAdmin.deletePeriod,
  getCustomer: state.reducer.closedPeriodsAdmin.getCustomer,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(closedPeriodsAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  reportFileActions: bindActionCreators(reportFileActions, dispatch)
});

ClosedPeriodsAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClosedPeriodsAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/closedPeriodsAdmin/index.jsx